import { StorageKeys } from '@/modules/common/services/local-storage';
import { BaseHttpClient } from '@/modules/common/services/http/__deprecated__/base-http-client';
import { TransactionData } from './exchange-types';

export default class ExchangeAPI extends BaseHttpClient {
  constructor() {
    super(StorageKeys.AccessToken, `${process.env.VUE_APP_BFF_URL}/exchange`);
  }

  public getExchange(id: string): Promise<TransactionData> {
    return this.get(`/v1/exchange/${id}`);
  }
}
